(function userPanel(el) {
  if (!el) {
    return;
  }

  Vue.use(DmtkWS);
  Vue.use(PanelDataSource);

  const panelRouter = new VueRouter({
    routes: [
      {
        path: '/perfil',
        component: ProfileModule,
        children: [
          { path: 'informacion', component: ProfileInfo },
          { path: 'experiencia', component: ProfileExperience },
          { path: 'disponibilidad', component: ProfileAvailability },
          { path: 'notificaciones', component: ProfileNotifications },
          {
            path: 'servicios',
            component: ProfileServices,
            children: [
              {
                path: 'nuevo',
                component: ProfileServicesForm,
                props: { id: false },
              },
              {
                path: ':id',
                component: ProfileServicesForm,
                name: 'service.form',
                props: true,
              },
              { path: '', component: ProfileServicesList },
            ],
          },
          { path: 'compartir', component: ProfileShare },
          { path: '', redirect: 'informacion' },
        ],
      },
      {
        path: '/empleo',
        component: JobsModule,
        children: [
          { path: 'nuevo', component: JobsForm, props: { id: false } },
          {
            path: 'editar/:id',
            component: JobsForm,
            name: 'job.form',
            props: true,
          },
          {
            path: ':id',
            component: JobsView,
            name: 'job.view',
            props: true,
          },
          { path: '', component: JobsStart },
        ],
      },
      {
        props: true,
        path: '/mensajes',
        component: MessagesModule,
        children: [
          {
            path: ':tid',
          },
        ],
      },
      { path: '/inscripciones', component: ApplicationsModule },
      { path: '/cuenta', component: AccountModule },
      { path: '/notificaciones', component: NotificationsModule },
      { path: '*', redirect: '/notificaciones' },
    ],
  });

  new Vue({
    store,
    router: panelRouter,
    components: {
      'profile-banners': ProfileBanners,
    },
    computed: {
      ...Vuex.mapState(['user', 'profile', 'notifications', 'unread']),
      session() {
        return domestiko.user;
      },
      module() {
        return this.$route.path.split('/')[1];
      },
    },
    watch: {
      $route(to, from) {
        window.scrollTo(0, 0);
        if (!to.path.includes('/mensajes')) {
          this.updateUserData();
        }
      },
    },
    created: function () {
      this.updateUserData();
      domestiko.$on('user.update', this.updateUserData);
      domestiko.$on('user.loggedout', () => {
        document.location.href = '/usuarios/salir';
      });
    },
    methods: {
      updateUserData() {
        this.$dmtk.user.get().then((data) => {
          data.unread = data.user.messages;
          this.$store.commit('set', data);
          domestiko.notifications(data.user.notifications);
        });
      },
      resend() {
        this.$dmtk.user.resend().then((data) => {
          customAlert(
            'Se te ha reenviado el correo para validar tu cuenta',
            'Por favor consulta tus mensajes y pincha en el enlace de validación.',
          );
        });
      },
      whitelist() {
        this.$dmtk.user.whitelist().then((data) => {
          delete this.user.blacklisted;
          this.$store.commit('user', { ...this.user });
          UIkit.modal.alert(
            'Se han activado los correos electrónicos. Por favor añádenos a tu libreta de direcciones y no nos marques como spam.',
          );
        });
      },
    },
  }).$mount(el);
})(document.getElementById('app'));
